import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import Medal from '../../components/Medal'
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class CoworkCard extends Component {
    handleClickReserve(event, id) {
        event.stopPropagation();
        this.props.history.push(`${URI_VENTA_EN_LINEA}/cowork/coworkedpayment/${id}`)
    }

    handleClickInfo(id) {
        this.props.history.push(`${URI_VENTA_EN_LINEA}/cowork-info/${id}`);
    }

    render() {
        const coworks = this.props.coworks;
        const urlimg = "https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/";
        return (
            <div className="list-card-resvations" >
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="row list list2">
                            {coworks.map((cowork) => (
                                <div
                                    className="col-xs-12 col-sm-6 col-md-6 card-panel-rooms"
                                    key={cowork.id}
                                    onClick={() => this.handleClickInfo(cowork.id)}>
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading">
                                            <img className="background-img" src={urlimg + cowork.id} alt="Fondo" />
                                            <Medal type={cowork.coworks_clasificacion} />
                                        </div>
                                        <article className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{cowork.centro_name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="panel-description-text">
                                                    {'  '}{cowork.centro_direccion}, {cowork.centro_ciudad}
                                                    {', '}{cowork.centro_estado}, {cowork.centro_cp}
                                                </div>
                                                <div className="panel-description-information">
                                                    <div className="contenedor-flexbox">
                                                        <p>Precios: </p>
                                                    </div>
                                                    <div className="contenedor-flexbox">
                                                        <p>$ 3,000.00/dia - </p>
                                                        <p>$ 6,000.00/semana - </p>
                                                        <p>$ 12,000.00/mes</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="form-group">
                                                    <button
                                                        onClick={(e) => this.handleClickReserve(e, cowork.id)}
                                                        className="btn btn-block btn-primary"
                                                        type="button">
                                                        <Trans>venta_linea.index.cowork.reserve</Trans>
                                                    </button>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    withRouter,
    translate('common')
)(CoworkCard);



// WEBPACK FOOTER //
// ./src/store/Cowork/CoworkCard.js